<template>
  <v-dialog v-model="dialog" persistent width="1300">
    <v-card class="py-0">
      <v-card-title class="headline ma-0">
        <v-flex xs9> <v-icon>schedule</v-icon> Marcados </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-container grid-list-md style="min-width: 100%;" class="p-0">
            <v-layout wrap row>
              <v-flex md6 xs12>
                <strong class="blue--text">DEPENDENCIA: </strong
                >{{ form.nombre_unidad }}
              </v-flex>
              <v-flex xs12 md6>
                <strong class="blue--text">SERVIDOR PÚBLICO: </strong
                >{{ form.nombres }} {{ form.ap_paterno }} {{ form.ap_materno }}
              </v-flex>
            </v-layout>
            <!--MARCADOS ORIGINALES  -->
            <v-layout wrap justify-space-between>
              <v-flex grow>
                <v-text-field
                  class="text-field-reducido"
                  type="date"
                  v-model="fecha_desde"
                  @input="mostrarMarcadosOriginalesBandera(type)"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  color="#16516f"
                  label="Fecha desde"
                />
              </v-flex>
              <v-flex grow>
                <v-text-field
                  class="text-field-reducido"
                  type="date"
                  v-model="fecha_hasta"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                  color="#16516f"
                  label="Fecha hasta"
                  @input="mostrarMarcadosOriginalesBandera(type)"
                />
              </v-flex>
              <v-flex shrink>
                <v-btn color="#812595" dark icon @click="verReporte()">
                  <v-icon>picture_as_pdf</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-space-between>
              <v-flex shrink class="text-xs-center">
                <v-checkbox
                  class="text-field-reducido"
                  v-model="type"
                  label="Ver marcados procesados"
                  @change="mostrarMarcadosOriginalesBandera(type)"
                ></v-checkbox>
              </v-flex>
              <v-flex shrink>
                <p v-if="this.type == true">
                  <strong>TOTAL ATRASOS:</strong> {{ total_atrasos }}
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-text class=" pa-0">
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          v-if="type == true"
          :headers="headers2"
          :items="lista_tipificados"
          :no-data-text="loading2 ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading2"
          item-key="index"
          :rows-per-page-items="[5, 10, 20, { text: 'Todos', value: -1 }]"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.dia }}</td>
            <td class="text-xs-center">
              {{ props.item.fecha_marcado }}
            </td>
            <td class="text-xs-center">{{ props.item.atraso }}</td>
            <td class="text-xs-center">
              <v-layout
                v-if="props.item.loading != true"
                align-center
                justify-space-between
              >
                <table class="table-marcado">
                  <tr>
                    <th>Horario</th>
                    <th>Marcado</th>
                    <th>Atraso</th>
                    <th>Descripción</th>
                  </tr>
                  <tr
                    v-for="marcado in props.item.marcados"
                    :key="marcado.id_control_asistencia"
                    :style="
                      marcado.atraso > 0
                        ? 'background:rgb(219, 62, 177,0.3'
                        : marcado.tipo_marcado == 'I'
                        ? 'background:rgb(252, 76, 2,0.3'
                        : ''
                    "
                  >
                    <td style="width: 15%;">{{ marcado.horario }}</td>
                    <td style="width: 15%">
                      {{ marcado.hora_marcada ? marcado.hora_marcada : "-" }}
                    </td>
                    <td style="width: 15%">{{ marcado.atraso }}</td>
                    <td style="width: 55%;">{{ marcado.descripcion_caso }}</td>
                  </tr>
                  <tr v-if="props.item.marcados.length == 0">
                    <td colspan="4"><b>NO CUENTA CON MARCADOS</b></td>
                  </tr>
                </table>
              </v-layout>
              <v-progress-circular
                v-if="props.item.loading == true"
                :width="5"
                :size="70"
                color="green"
                indeterminate
              ></v-progress-circular>
            </td>
            <td>
              <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  color="#00B2A9"
                  dark
                  icon
                  :loading="props.item.loading == true"
                  @click="actualizaTipificaDia(props.item)"
                >
                  <v-icon>update</v-icon>
                </v-btn>
                <span>Actualizar marcados</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          v-if="type == false"
          :headers="headers"
          :items="lista"
          :no-data-text="loading ? 'Cargando...' : 'No se tiene registros'"
          :disable-initial-sort="true"
          :loading="loading"
          item-key="index"
          :rows-per-page-items="[20, 40, { text: 'Todos', value: -1 }]"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">{{ props.item.dia }}</td>
            <td class="text-xs-center">{{ props.item.fecha }}</td>
            <td class="text-xs-center">{{ props.item.hora }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  // Variables iniciales
  mixins: [validate],
  data() {
    return {
      valid: false,
      dialog: false,
      persona: {},
      form: {},
      loading: false,
      loading2: false,
      valid: false,
      total_atrasos: 0,
      bandera_genera: false,
      fecha_desde: null,
      fecha_hasta: null,
      bandera_desde: 0,
      bandera_hasta: 0,
      mes: null,
      gestion: null,
      headers: [
        {
          text: "Dia",
          sortable: false,
          value: "dia",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha",
          sortable: false,
          value: "fecha",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora",
          sortable: false,
          value: "hora",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Día",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Fecha",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Retraso en min.",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Detalle marcados",
          sortable: false,
          value: "",
          align: "center"
        },
        {
          text: "Acciones",
          sortable: false,
          value: "",
          align: "center"
        }
      ],
      lista: [],
      listaOriginales: [],
      lista_tipificados: [],
      fechas: {
        desde: "",
        hasta: ""
      },
      atrasosMin: 0,
      type: false, //marcados originales por defecto
      check: {
        falta: true,
        no_falta: false
      },
      user: this.$storage.get("user")
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerMarcadosPasante", async item => {
      this.form = item;
      const fecha = new Date();
      this.gestion = fecha.getFullYear();
      this.mes = fecha.getMonth() + 1;
      let primer_dia_mes = new Date(this.gestion, this.mes - 1, 1);
      let ultimo_dia_mes = new Date();
      this.fecha_desde = this.$moment(primer_dia_mes).format("YYYY-MM-DD");
      this.fecha_hasta = this.$moment(ultimo_dia_mes).format("YYYY-MM-DD");
      await this.mostrarMarcadosOriginalesBandera(true);
      this.dialog = true;
    });
  },
  methods: {
    verReporte() {
      let url = this.$util.getUrlReporte(
        "marcados",
        "rpt_asistencia_general2",
        "pdf",
        {
          fecha_inicio: this.fecha_desde,
          fecha_fin: this.fecha_hasta,
          id_persona:  this.form.id_persona
        }
      );
      this.$bus.$emit("openDialogVerReporte", url);
    },
    //Actualiza tipifica del dia
    async actualizaTipificaDia(item) {
      item.loading = true;
      var fecha_marcado = this.$moment(item.fecha_marcado, "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      );
      await this.$service
        .graphql({
          query: `
            query{
              runQuery(consulta: "SELECT planilla.fn_tipifica_por_rango_de_fechas_pasante(${this.form.id_persona},'${fecha_marcado}','${fecha_marcado}')"){
                respuesta
              }
            }
          `
        })
        .then(async response => {
          if (response) {
            let res = response.runQuery.respuesta[0].fn_tipifica_por_rango_de_fechas_pasante.split(
              "|"
            );
            if (res[0] == "1") {
              let rpta = await this.$service.graphql({
                query: `
                  query{
                    getMarcadosTipificado(id_persona:${this.form.id_persona},fecha_desde:"${fecha_marcado}",fecha_hasta:"${fecha_marcado}"){
                      total_atrasos
                      rows{
                        fecha_marcado
                        dia
                        atraso
                        loading:fecha_marcado
                        marcados{
                          id_control_asistencia
                          hora_marcada
                          horario
                          descripcion_caso
                          atraso
                          tolerancia
                          tipo_marcado
                        }
                      }
                    }
                  }
                `
              });
              this.total_atrasos -= item.atraso;
              var marcados_dia = rpta.getMarcadosTipificado;
              item.marcados = marcados_dia.rows[0].marcados;
              item.atraso = marcados_dia.rows[0].atraso;
              this.total_atrasos += item.atraso;
              this.$message.success(
                "Se actualizo los marcados del dia seleccionado correctamente"
              );
              item.loading = false;
            } else {
              this.$message.error(res);
              item.loading = false;
            }
          }
        });
    },

    async mostrarMarcadosOriginalesBandera(tipo) {
      try {
        this.lista = [];
        this.lista_tipificados = [];
        var fecha_desde_formateada = this.$moment(this.fecha_desde).format(
          "YYYY-MM-DD"
        );
        var fecha_hasta_formateada = this.$moment(this.fecha_hasta).format(
          "YYYY-MM-DD"
        );
        if (
          fecha_desde_formateada === "Invalid date" ||
          fecha_hasta_formateada === "Invalid date"
        ) {
          this.$message.info("Una de las fechas es invalida");
          return;
        }
        if (this.fecha_desde && this.fecha_hasta) {
          if (this.type == false) {
            await this.obtenerAsistencias();
          } else {
            const fecha = new Date();
            this.gestion = fecha.getFullYear();
            this.mes = fecha.getMonth() + 1;
            await this.obtenerAsistenciasTipificadas();
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerAsistenciasTipificadas() {
      try {
        this.loading2 = true;
        if (this.fecha_desde && this.fecha_hasta) {
          let rpta = await this.$service.graphql({
            query: `
            query{
              getMarcadosTipificado(id_persona:${this.form.id_persona},fecha_desde:"${this.fecha_desde}",fecha_hasta:"${this.fecha_hasta}"){
                total_atrasos
                rows{
                  fecha_marcado
                  dia
                  atraso
                  loading:fecha_marcado
                  marcados{
                    id_control_asistencia
                    hora_marcada
                    horario
                    descripcion_caso
                    atraso
                    tolerancia
                    tipo_marcado
                  }
                }
              }
            }
            `
          });
          var marcados = rpta.getMarcadosTipificado;
          this.lista_tipificados = marcados.rows;
          this.total_atrasos = marcados.total_atrasos;
          this.loading2 = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerAsistencias() {
      try {
        this.loading = true;
        let res = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta: " SELECT * FROM control.fn_marcados_biometrico_sin_procesar(${this.form.id_persona}, '${this.fecha_desde}', '${this.fecha_hasta}') AS (unidad TEXT , nombres TEXT, dia TEXT, fecha TEXT, hora TEXT)"){
                    respuesta
                  }
                }
              `
        });

        if (res.runQuery.respuesta) {
          this.lista = res.runQuery.respuesta;
        } else {
          this.atrasosMin = 0;
          this.lista = [{}];
        }
        this.loading = false;
        this.bandera_genera = true;
      } catch (error) {
        console.log(error);
      }
    },

    close() {
      this.loading = false;
      this.dialog = false;
      this.url = "";
    }
  }
};
</script>
<style lang="scss" scoped>
.color_letras {
  color: azure;
}
.table-marcado {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.9em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.9em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/pasantes/dialogs/VerMarcados.vue